import { Statistic } from '@helpers/statistics.ts';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

interface MetricsTableProps {
  metrics: Statistic | null | undefined;
}

export const MetricsTable = (props: MetricsTableProps) => {
  if (!props.metrics) return null;
  if (!props.metrics.zones) return null;

  return (
    <Paper variant={'outlined'} elevation={0} sx={{ padding: 0 }}>
      <TableContainer>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Zona</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Total</strong>
                <hr style={{ margin: 0 }} />
                <small>[{props.metrics.total ?? ''}]</small>
              </TableCell>
              <TableCell align="center">
                <strong>COD</strong>
                <hr style={{ margin: 0 }} />
                <small>[{props.metrics.total_cod ?? ''}]</small>
              </TableCell>
              <TableCell align="center">
                <strong>XS</strong>
                <hr style={{ margin: 0 }} />
                <small>[{props.metrics.total_xs ?? ''}]</small>
              </TableCell>
              <TableCell align="center">
                <strong>S</strong>
                <hr style={{ margin: 0 }} />
                <small>[{props.metrics.total_s ?? ''}]</small>
              </TableCell>
              <TableCell align="center">
                <strong>M</strong>
                <hr style={{ margin: 0 }} />
                <small>[{props.metrics.total_m ?? ''}]</small>
              </TableCell>
              <TableCell align="center">
                <strong>L</strong>
                <hr style={{ margin: 0 }} />
                <small>[{props.metrics.total_l ?? ''}]</small>
              </TableCell>
              <TableCell align="center">
                <strong>XL</strong>
                <hr style={{ margin: 0 }} />
                <small>[{props.metrics.total_xl ?? ''}]</small>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.metrics.zones.map((metric) => (
              <TableRow hover key={`${metric.id}`}>
                <TableCell>{metric.name}</TableCell>
                <TableCell align="center">{metric.total}</TableCell>
                <TableCell align="center">{metric.metrics.cod}</TableCell>
                <TableCell align="center">{metric.metrics.xs}</TableCell>
                <TableCell align="center">{metric.metrics.s}</TableCell>
                <TableCell align="center">{metric.metrics.m}</TableCell>
                <TableCell align="center">{metric.metrics.l}</TableCell>
                <TableCell align="center">{metric.metrics.xl}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
